<template>
  <div style="background-color: #ffffff; position: relative; height: 498px">
    <div v-if="!wxuser" class="reglogin">
      <span @click="login()" v-if="!wxuser">立即登录，参与互动</span>
    </div>

    <div v-if="wxuser">
      <ul id="box">
        <!--不是管理员的信息-->
        <li v-for="(msg, i) in lists" :key="i">
          <div
            v-show="msg.userid != wxuser.uId && msg.type != 'g'"
            class="content"
          >
            <img :src="msg.uIcon || defaultHead" class="u-icon" alt />
            <span class="other">
              <span
                style="font-size: 0.26rem"
                :class="{ teacher: msg.type == 1 ? true : false }"
              >
                {{ msg.username }}
                <span v-if="msg.type == 1" class="teacher">(讲师)</span>
              </span>
              <span
                style="color: #666666;"
                class="dialog-content"
                >{{ msg.content }}</span
              >
            </span>
          </div>
          <div
            v-show="msg.userid == wxuser.uId && msg.type != 'g'"
            class="isMe"
          >
            <img :src="msg.uIcon || defaultHead" alt class="u-icon" />
            <span class="self" v-show="msg.userid == wxuser.uId">
              <span style="color: #ff781b; font-size: 0.22rem" class="nick-name"
                >我</span
              >
              <span
                style="color: #666666;"
                class="dialog-content"
                >{{ msg.content }}</span
              >
            </span>
          </div>
          <div class="reword" v-if="msg.type == 'g'">
            <span>{{ msg.username }} 送出</span>
            <img :src="JSON.parse(msg.content).gUrl" />
            <!-- <span>{{rewardList.find(v=>v.gId==msg.content).gUrl}}</span> -->
          </div>
        </li>
      </ul>
      <div style="width: 100%; height: 25px; background: #f7f7f7"></div>
      <div
        :class="[showReward ? 'rewardWrapShow' : 'rewardWrap', 'commReward']"
      >
        <ul class="rewardList" v-show="!showCustom && !payqrcode">
          <li
            v-for="item in rewardList"
            :key="item.gName"
            @click="sendGift(item)"
          >
            <img :src="item.gUrl" alt="" srcset="" />
            <span>{{ item.gName }}</span>
            <b>￥{{ item.gMoney }}</b>
          </li>
        </ul>
        <div v-show="payqrcode" class="code_content">
          <span class="icon_close" @click="handleClose">X</span>
          <p>请微信扫码支付</p>
          <div id="con_qrcode" ref="qrcode"></div>
        </div>
        <div class="custom" v-show="showCustom">
          <div class="topTitle">
            <i class="iconfont" @click="showCustom = false">&#xe619;</i>
            自定义金额
          </div>
          <div class="setMoney">
            <span>金额</span>
            <input type="number" placeholder="请输入金额" />
            <span>元</span>
          </div>
          <div class="sureBtn">确认打赏</div>
        </div>

        <div v-if="!payqrcode" class="closeReward" @click="showReward = false">
          <i class="iconfont">&#xe602;</i>
        </div>
      </div>
      <div v-show="!isForbidden && !userForBidden" class="sendBox">
        <img
          class="reward"
          @click="showReward = true"
          src="./imgs/reward.png"
          alt=""
        />
        <div class="inp_send">
          <textarea
            name=""
            cols="30"
            rows="10"
            placeholder="说说我的看法！"
            v-model="content"
            id="inp"
          ></textarea>
          <button class="send" @click="send('m')">发 送</button>
        </div>
      </div>

      <div v-show="isForbidden || userForBidden" class="roomtips">
        {{ forbenDesc }}
      </div>
    </div>
  </div>
</template>
<script>
import bus from "../bus/index.js";

import LikeHeart from "../../../static/js/canvas";
import QRCode from "qrcodejs2"; //二维码
import loginService from '../../plugin/extendFn/loginService.js';
import AppSetting from '../../AppSetting.js';
// import vueEmoji from '../emoji/emoji.vue'
// console.log(bus);
export default {
  data() {
    return {
      payqrcode: false,
      showCustom: false,
      defaultHead: require("../../assets/images/headericon.png"),
      showReward: false, // 是否显示打赏列表
      width: 175, //初始宽度
      heightcan: 400, //初始高度
      heartList: [], //初始数组
      heartCount: 0, //累加计数初始值

      content: "",
      speakShow: false,
      showEmoji: false,
      zeroCdate: 0,
      lists: [],
      flag: true, //查询数据库开关
      mmsg: "",
      uId: "",
      color: "#0062db",
      chatUname: "", //用户的昵称
      showNameCover: true,
      bottombar: true,
      wxuser: null,
      socket: io.connect(this.GLOBAL.SOCKETPORT),

      onpresscTime: 0, //  阻止短时间内连续点击
      question: 0, //直播是否已进行过答题
      rewardList: [],

      isForbidden: false, // 聊天室禁言 true 整个房间禁言  false 放开禁言
      userForBidden: false, // 用户被禁言 true 整个房间禁言  false 放开禁言
    };
  },
  props: ["ClassTimePlayer", "videoUrl"],
  props: {
    dmid: {
      type: String,
      default: () => {
        return "2008";
      },
    },
    height: {
      type: Number,
    },
    user: {
      type: Object,
    },
    manager: {},
  },
  watch: {
    manager(newv, oldv) {
      console.log("新数据", newv);
      if (newv == 1) {
        //开始答题
        let params = {
          adminid: this.wxuser ? this.wxuser.uId : "0",
          roomid: this.$route.query.liveId,
        };
        console.log("监听的参数变化了  发送这些参数", params);
        this.socket.emit("startQuestion", params);
      } else if (newv == 0) {
        //取消答题
        let params = {
          adminid: this.wxuser ? this.wxuser.uId : "0",
          roomid: this.$route.query.liveId,
        };
        console.log("监听的参数变化了  发送这些参数", params);
        this.socket.emit("cancelQuestion", params);
      }
    },
  },
  computed: {
    forbenDesc() {
      let desc = "此直播间已经禁言";
      if (!this.isForbidden) {
        if (this.userForBidden) {
          desc = "您已被禁言";
        }
      }
      return desc;
    },
  },
  methods: {
    login() {
      loginService.login(this.$router).then((loginUser) => {
        this.wxuser = loginUser;
      });
    },
    handleClose() {
      document.getElementById("con_qrcode").innerHTML = "";
      this.payqrcode = false;
    },
    userForben() {
      let param = {
        userid: this.wxuser.uId,
        roomid: this.$route.query.liveId,
        adminid: this.wxuser.uId,
      };

      this.socket.emit("roomShutSingle", param);
    },
    notUserForben() {
      let param = {
        userid: this.wxuser.uId,
        roomid: this.$route.query.liveId,
        adminid: this.wxuser.uId,
      };

      this.socket.emit("roomOpenSingle", param);
    },
    forben() {
      let param = {
        userid: this.wxuser.uId,
        roomid: this.$route.query.liveId,
        adminid: this.wxuser.uId,
      };

      this.socket.emit("roomShutAll", param);
    },
    notforben() {
      let param = {
        userid: this.wxuser.uId,
        roomid: this.$route.query.liveId,
        adminid: this.wxuser.uId,
      };

      this.socket.emit("roomOpenAll", param);
    },

    getGiftList() {
      this.$postHttp(AppSetting.baseUrl + "/common/gift/list", {}).then((res) => {
        let data = res.data;
        if (data.code === 0) {
          this.rewardList = data.data;
          // this.rewardList.push({
          //   gFl: "1",
          //   gId: 999,
          //   gMoney: 1,
          //   gName: "现金",
          //   gOrder: 1,
          //   type: 2,
          //   gUrl: require('./imgs/reward2.png')
          // })
        }
      });
    },
    async sendGift(item) {
      if (await loginService.isNotLogin()) {
        //没有id 直接去登录注册
        this.login();
      } else {
        if (item.gMoney == 0) {
          //免费的不走支付的逻辑 相当于发言类型
          let msgParam = {
            userid: this.wxuser.uId,
            username: this.wxuser.uName
              ? this.wxuser.uName
              : this.wxuser.uUsername
              ? this.wxuser.uUsername
              : "",
            usericon: this.wxuser.sIcon,
            roomid: this.$route.query.liveId,
            content: JSON.stringify(item),
            type: "g", //普通消息
            cdate: new Date().getTime(),
          };

          this.socket.emit("message", msgParam);
        } else {
          this.payqrcode = true;
          let param = {
            type: 1, //指pc端
            orderType: 4, //vip购买，1 视频购买，2直播购买，3会议购买  4直播打赏
            bId: this.$route.query.liveId,
            relId: item.gId,
            originalPrice: item.gMoney,
            payPrice: item.gMoney,
            uid: this.wxuser.uId,
          };
          this.$postHttp(AppSetting.baseUrl + "/order/app/add", param).then((res) => {
            if (res.data.code == 0) {
              const pay_params = JSON.parse(res.data.parMap);
              let orderid = res.data.id;
              let qrcode = new QRCode(this.$refs.qrcode, {
                text: pay_params.code_url,
                width: 100,
                height: 100,
                colorDark: "#333333", //二维码颜色
                colorLight: "#ffffff", //二维码背景色
                correctLevel: QRCode.CorrectLevel.H, //容错率，L/M/H
              });

              let timer = setInterval(() => {
                this.$postHttp(AppSetting.baseUrl + "/order/app/search", {
                  id: orderid,
                }).then((result) => {
                  if (result.data.code == 0) {
                    //data.orderStatus 0未支付，1支付成功，2支付失败
                    if (result.data.data.orderStatus == 1) {
                      this.$message.success("支付成功！");
                      let msgParam = {
                        userid: this.wxuser.uId,
                        username: this.wxuser.uName
                          ? this.wxuser.uName
                          : this.wxuser.uUsername
                          ? this.wxuser.uUsername
                          : "",
                        usericon: this.wxuser.sIcon,
                        roomid: this.$route.query.liveId,
                        content: JSON.stringify(item),
                        type: "g", //普通消息
                        cdate: new Date().getTime(),
                      };

                      this.socket.emit("message", msgParam);
                      document.getElementById("con_qrcode").innerHTML = "";
                      window.clearInterval(timer);
                      this.payqrcode = false;
                    } else if (result.data.data.orderStatus == 2) {
                      this.$message.success("支付失败！");
                      window.clearInterval(this.timer);
                      document.getElementById("con_qrcode").innerHTML = "";
                      this.payqrcode = false;
                    }
                  } else if (result.data.code == 2004) {
                    this.$message.error("订单号为空");
                  } else {
                    this.$message.error("查询失败");
                  }
                });
              }, 2000);
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      }
    },

    send() {
      if (this.content == "" || this.content.length < 1) {
        return false;
      } else {
        let msgParam = {
          userid: this.wxuser.uId,
          username: this.wxuser.uName
            ? this.wxuser.uName
            : this.wxuser.uUsername
            ? this.wxuser.uUsername
            : "",
          usericon: this.wxuser.sIcon,
          roomid: this.$route.query.liveId,
          content: this.content,
          type: "m", //普通消息
          cdate: new Date().getTime(),
        };
        console.log("shu", msgParam);
        this.content = "";
        this.socket.emit("message", msgParam);
      }
    },
  },
  async mounted() {
    this.wxuser = await loginService.getLoginUser();

    this.getGiftList();
    const h = document.body.scrollHeight; // 用onresize事件监控窗口或框架被调整大小，先把一开始的高度记录下来
    window.onresize = function () {
      // 如果当前窗口小于一开始记录的窗口高度，那就让当前窗口等于一开始窗口的高度
      if (document.body.scrollHeight < h) {
        document.body.style.height = 100 + "vh";
      }
    };
    let userId;
    if (
      this.wxuser == "null" ||
      this.wxuser == null ||
      this.wxuser == "" ||
      this.wxuser == undefined
    ) {
      userId = parseInt(Math.random() * 100000000);
    }
    if (!this.socket.connected) {
      this.socket.connect(); //初始化后连接  io.connect(this.GLOBAL.SOCKETPORT)这个是整个socket对象返回的数据
    }

    let param = {
      userid: this.wxuser ? this.wxuser.uId : userId,
      roomid: this.$route.query.liveId,
      username: this.wxuser ? this.wxuser.uName : userId,
      usericon: this.wxuser ? this.wxuser.uIcon : "",
    };
    // console.log('连接参数',param)
    this.socket.emit("login", param);
    bus.$emit("noticeUser", param);
    this.socket.on("connect", () => {
      console.log("监听connect");
    });
    this.socket.on("disconnect", (obj) => {
      // alert('断开了')
      console.log("断开连接---");
      this.socket = io.connect(this.GLOBAL.SOCKETPORT); //监听重新连接
      console.log(param);
      this.socket.emit("login", param);
    });
    let self = this;
    this.socket.on("online", function (data) {
      self.$emit("onlineuser", data.online_count);
      console.log("online user is :" + data.online_count);
    });

    this.socket.on("stat", function (data) {
      //葛兰素史克在线累计人数
      self.$emit("onlinecount", data.view_count);
    });

    this.socket.on("message", (obj) => {
      console.log(
        "收到来自服务端的普通消息,房间号====" + this.$route.query.liveId
      );
      // console.log(obj)
      let person = {
        userid: obj.userid,
        username: obj.username,
        usericon: obj.usericon,
        content: obj.content,
        roomid: this.$route.query.liveId,
        type: obj.type, //欢迎消息
        cdate: new Date().getTime(),
      };
      console.log("message------>", person);

      this.lists.push(person);
      setTimeout(() => {
        let box = document.getElementById("box");
        console.log("里面元素高度", box.scrollHeight);
        console.log(box);
        box.scrollTop = box.scrollHeight;
      }, 200);
    });
    this.socket.on("queryAll", (results) => {
      console.log("LIEBIAO", results);
      this.lists = results;
      this.flag = false;
      setTimeout(() => {
        let box = document.getElementById("box");
        // console.log('里面元素高度',box.scrollHeight)
        box.scrollTop = box.scrollHeight;
      }, 200);
    });
    this.socket.on("roomShutAll", (results) => {
      this.isForbidden = true;
    });
    this.socket.on("roomOpenAll", (results) => {
      this.isForbidden = false;
    });

    this.socket.on("roomShutSingle", (results) => {
      if (this.wxuser.uId == results.userid) {
        this.userForBidden = true;
      }
    });
    this.socket.on("roomOpenSingle", (results) => {
      if (this.wxuser.uId == results.userid) {
        this.userForBidden = false;
      }
    });
  },
  destroyed() {
    // alert('退出聊天')
    this.socket.close();
    this.socket.removeAllListeners(); //清空聊天监听的数据
  },

  components: {},
};
</script>
<style scoped="scoped" lang="scss">
.roomtips {
  position: absolute;
  bottom: 0rem;
  left: 0;
  width: 100%;
  height: 50px;
  text-align: center;
  line-height: 0.7rem;
  border-top: 1;
  background: #e6e6e6;
  font-size: 12px;
  color: #333;
  // margin: 0 auto;
}
.icon_close {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 20px;
}
.code_content {
  text-align: center;
  padding: 30px 20px;
  box-sizing: border-box;
}
#con_qrcode {
  width: 100px;
  height: 100px;
  margin: 20px auto;
  display: inline-block;
}
.u-icon {
  margin-right: 5px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
}
.content {
  display: flex;
  align-items: center;
}
.reword {
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  color: #999;

  img {
    width: 40px;
    height: 40px;
    margin-left: 10px;
  }
}

.isMe {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  .nick-name {
    text-align: right;
  }
  .self {
    margin-right: 5px;
    display: flex;
    flex-direction: column;
  }
}

.reward {
  margin-left: 0;
  margin-right: 20px;
  width: 40px;
  height: 40px;
}
.username {
  flex-shrink: 0;
}
.commReward {
  position: absolute;
  width: 380px;
  height: 250px;
  bottom: 380px;
  transition: bottom 1s;
  left: right;
  z-index: 10;
  background: #f5f5f9;
  .rewardList {
    overflow: hidden;
    display: flex;
    align-content: flex-start;

    flex-wrap: wrap;
    li {
      width: 70px;
      flex-wrap: wrap;
      padding-top: 10px;
      cursor: pointer;
      // flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      /*&:nth-last-child(1) {*/
      /*img {*/
      /*width: 30px;*/
      /*height: auto;*/
      /*}*/
      /*}*/

      img {
        width: 30px;
        height: 30px;
      }
      span {
        font-size: 13px;
      }

      b {
        font-size: 12px;
        color: #999;
      }
    }
  }
  .closeReward {
    position: absolute;
    left: 50%;
    bottom: 0px;
    margin-left: -20px;
    cursor: pointer;
    z-index: 10000;
    .iconfont {
      font-size: 20px;
    }
  }
  .custom {
    font-size: 30px;
    .topTitle {
      line-height: 40px;
      border-bottom: 1px solid #e6e6e6;
      font-size: 16px;
      text-align: center;
      color: #333;
      position: relative;
      .iconfont {
        position: absolute;
        left: 20px;
        top: 2px;
        font-size: 18px;
        transform: rotate(180deg);
        cursor: pointer;
      }
    }
    .setMoney {
      font-size: 24px;
      background: #fff;
      width: 350px;
      display: flex;
      height: 60px;
      align-items: center;
      border-radius: 5px;
      margin: 30px auto 0;
      box-sizing: border-box;
      padding: 0 20px;

      input {
        font-size: 18px;
        outline: none;
        border: 0;
        width: 160px;
        margin-left: 60px;
      }
    }
    .sureBtn {
      width: 300px;
      height: 40px;
      margin: 40px auto 0;
      text-align: center;
      background: #f35135;
      color: #fff8c6;
      line-height: 40px;
      border-radius: 10px;
      font-size: 18px;
      cursor: pointer;
    }
  }
}
.main {
  position: relative;
  width: 380px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  .notice {
    width: 20px;
    height: 20px;
    line-height: 20px;
    display: inline-block;
    position: relative;
    top: 4px;
  }

  > span {
    color: #1567f5;
    text-align: left;
    height: 30px;
    line-height: 30px;
    width: 100%;
    display: inline-block;
    -webkit-animation: scrollGood 10s linear infinite;
    animation: scrollGood 10s linear infinite;
    position: absolute;
    left: 345px;
  }
}
.other {
  display: flex;
  flex-direction: column;
  color: #5cadff;
  justify-content: start;
  /*flex-wrap: wrap;*/
  max-width: 90%;
  .teacher {
    color: #b10000 !important;
  }
  span:nth-of-type(1) {
    flex-shrink: 0;
    max-width: 100%;
    color: #21afff;
  }
  span {
    display: inline-block;
  }
}
.other span {
  color: #333333;
}

.dialog-content {
  padding: 5px;
  border-radius: 5px;
  background: #f0f0f0;
  border-top-right-radius: 0;
  text-align: justify;
  text-justify: newspaper;
  word-break: break-all;
}

.self .con {
  text-align: left;
}

.journal-reward {
  position: absolute;
  bottom: 70px;
  right: 20px;
  height: 80px;
  width: 80px;
  display: block;
  z-index: 21;
}
.m {
  width: 750px;
  height: 1334px;
  margin-left: auto;
  margin-right: auto;
  /*background: url(img/bg.jpg) no-repeat;*/
  background-size: 100% 100%;
}
.usericon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
}
.qcode {
  padding: 0.1rem;
  background: #f0f0f0;
  position: relative;
  border-radius: 5px;
}
.delmanage {
  font-size: 14px;
  width: 100%;
  text-align: left;
  cursor: pointer;
  /*position: absolute;*/
  /*top: 40px;*/
  /*left: 40px;*/
  span {
    color: #0e94ff !important;
  }
}
.ichattext {
  font-size: 14px;
  img {
    width: 224px;
    display: block;
  }
  > div {
    word-wrap: break-word;
    display: flex;
    justify-content: flex-start;
    p:nth-of-type(3) {
      position: relative;
    }
  }
}
.context {
  word-wrap: break-word;
  max-width: 250px;
}
.contitem {
  display: flex;
  font-size: 0.28rem;
  align-items: flex-start;
  div {
    display: flex;
    /*word-wrap:break-word;*/
    flex-wrap: wrap;
    .other,
    .self {
      .myself {
        font-size: 14px;
      }
      p:nth-of-type(2) {
        font-size: 14px;
        /*color: #FFB441;*/
        /*padding: 10px;*/
        border-radius: 5px;
        box-sizing: border-box;
      }
    }
  }
}
input {
  -webkit-appearance: none; /*去除input默认样式*/
}
#box {
  background: #ffffff;
  overflow-y: scroll;
  /*width: 100vw;*/
  width: 100%;
  /*height: 476px;*/
  /*height: 100%;*/
  height: 423px;
  padding: 0 12px 0;
  box-sizing: border-box;
  position: relative;
  li {
    width: 100%;
    padding: 0.05rem 0;
  }
  li:nth-last-of-type(1) {
    margin-bottom: 30px;
  }
}
.reglogin {
  font-size: 14px;
  text-align: center;
  line-height: 100%;
  padding-top: 150px;
  span {
    color: #0e94ff !important;
    text-underline: #0e94ff;
    cursor: pointer;
  }
}
.send {
  /*width: 1.77rem;*/
  width: 51px;
  height: 40px;
  background: #ffb441;
  color: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  border: none;
  outline: none;
  cursor: pointer;
}
.inp_send {
  background: #ffffff;
  display: flex;
  width: 310px;
  align-items: center;
  height: 40px;
  /*padding: 0 0.28rem;*/
  box-sizing: border-box;
  border-radius: 4px;
  z-index: 9999;
  font-size: 14px;
  bottom: 0;
  .image {
    cursor: pointer;
    position: relative;
    border-right: 1px solid #cccccc;
    /*width: 1.19rem;*/
    /*width: 20%;*/
    /*height: 100%;*/
    width: 40px;
    height: 40px;
    font-weight: 100;
    /*height: 1.19rem;*/
    display: inline-block;
    font-size: 42px;
    text-align: center;
    flex-shrink: 0;
    line-height: 60px;
    color: #adadad;
    position: relative;
    input {
      position: absolute;
      display: inline-block;
      border: none;
      width: 100%;
      height: 100%;
      font-size: 0px;
      outline: none;
      opacity: 0;
      color: rgba(0, 0, 0, 0);
      backgroud: rgba(0, 0, 0, 0);
    }
  }
  textarea {
    /*width: 6.2rem;*/
    /*width: 4.53rem;*/
    width: 260px;
    height: 40px;
    /*border: 1px solid #e6e6e6;*/
    -webkit-appearance: none;
    border: none;
    outline: none;
    /*border-radius: 34px;*/
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 0.1rem;
    box-sizing: border-box;
    font-size: 14px;
    resize: none;
  }
  textarea::placeholder {
    color: #999999;
    /*line-height: 0.7rem;*/
  }
  textarea::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
  img {
    width: 0.48rem;
    height: 0.48rem;
    margin-left: 0.17rem;
  }
}
.box {
  background-color: #f4f5f4;
}
.sendBox {
  /*position: sticky;*/
  display: flex;
  position: absolute;
  bottom: 0rem;
  font-size: 0;
  left: 0;
  height: 50px;
  /*box-sizing: border-box;*/
  /*padding-left: .1rem;*/
  /*width: 100vw;*/
  width: 100%;
  z-index: 9;
  background: #f7f7f7;
  .image {
    margin-left: 7px;
    position: relative;
    img {
      width: 40px;
      height: 40px;
      z-index: 5;
    }
  }
}

.welcome {
  color: red;
}
.me {
  color: #ff781b;
  font-size: 14px;
  vertical-align: middle;
}
input {
  width: 5.8rem;
  /*height: rem;*/
  font-size: 0.3rem;
  /*border-radius: .2rem;*/
  border: 1px solid #e9e9e9;
}

.self {
  display: flex;
  justify-content: start;
  /*flex-wrap: wrap;*/
  max-width: 100%;
  span:nth-of-type(1) {
    flex-shrink: 0;
    max-width: 100%;
  }
  span {
    display: inline-block;
  }
}
.teachercon {
  color: #ffb441 !important;
  font-size: 14px;

  /*padding: 0.1rem;*/
  border-radius: 5px;
  box-sizing: border-box;
}
.other {
  display: flex;
  justify-content: start;
  /*flex-wrap: wrap;*/
  max-width: 100%;

  span:nth-of-type(1) {
    flex-shrink: 0;
    max-width: 100%;
  }
  span {
    display: inline-block;
  }
}
.other span {
  /*color: #FFB441;*/
  color: #222222;
}
.admin span {
}
.ichattext {
  font-size: 14px;
}
.con {
  /*padding: .1rem .05rem;*/
  border-radius: 0.1rem;
  display: inline-block;
  position: relative;
  /*max-width: 80%;*/
  line-height: 1.25;
  display: inline-block;
  /*padding: 0.1rem 0.2rem;*/
  color: #666;
  font-size: 0.28rem;
}
.left3 {
  display: inline-block;
  margin-top: 5px;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 10px solid #ffffff;
}
.right3 {
  display: inline-block;
  margin-top: 5px;
  margin-left: -4px;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 10px solid #ffffff;
}
.msgitem * {
  vertical-align: top;
}

.self .con {
  text-align: left;
}

.other .con {
  color: #333333;
  background: rgb(244, 245, 244);
}

.teacher {
  font-size: 14px;
  color: #b10000 !important;
  span {
    color: #b10000 !important;
  }
}

.rewardWrapShow {
  transition: bottom 0.8s;
  bottom: -15px;
}
.rewardWrap {
  bottom: -450px;
  transition: bottom 0.8s;
}
</style>



// WEBPACK FOOTER //
// src/components/iChat/iChat_old.vue